var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.816 15.035l-6.66-11.38a1.265 1.265 0 00-.48-.478 1.366 1.366 0 00-1.347 0c-.204.115-.37.28-.481.479L2.184 15.035a1.256 1.256 0 00-.01 1.288c.116.198.284.364.488.482.204.119.437.186.676.195H16.66c.24-.009.472-.076.676-.194a1.35 1.35 0 00.488-.482 1.255 1.255 0 00-.009-1.29zm-7.817-2.356c.347.007.676.144.916.38.24.236.37.552.363.878.007.327-.123.643-.363.879s-.57.372-.916.38a1.345 1.345 0 01-.914-.38 1.194 1.194 0 01-.363-.879 1.194 1.194 0 01.363-.878c.24-.236.568-.372.914-.38zM8.787 8.156a.306.306 0 01.088-.24.342.342 0 01.245-.106h1.76a.36.36 0 01.245.106.305.305 0 01.088.24l-.206 3.721a.315.315 0 01-.101.217.354.354 0 01-.232.093H9.33a.354.354 0 01-.231-.093.315.315 0 01-.101-.217l-.21-3.72z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default ForwardRef;